import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IconComponent } from './icon.component';
import type { InputSignal, Signal } from '@angular/core';

export type ArrowSize = 'regular' | 'large'

@Component({
  selector: 'td-wb-icon-arrow',
  templateUrl: './icon-arrow.component.html',
  styleUrls: ['./icon-arrow.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent]
})
export class IconArrowComponent {
  private static readonly ICON_ID_UP: string = 'arrow-gain';
  private static readonly ICON_ID_DOWN: string = 'arrow-loss';

  readonly value: InputSignal<number> = input.required<number>();
  readonly size: InputSignal<ArrowSize> = input<ArrowSize>('regular');
  readonly precision: InputSignal<number | undefined> = input<number>();

  readonly iconSize: Signal<string> = computed(() => this.size() === 'large' ? '12' : '9');

  readonly iconId: Signal<string> = computed(() => {
    const value: number | undefined = this.getAdjustedValue(this.value());
    if (typeof value === 'number') {
      if (value > 0) {
        return IconArrowComponent.ICON_ID_UP;
      }
      if (value < 0) {
        return IconArrowComponent.ICON_ID_DOWN;
      }
    }
    return '';
  });

  private getAdjustedValue(value: number | undefined): number | undefined {
    const precision = this.precision();
    if (value !== undefined && precision !== undefined) {
      return parseFloat(value.toFixed(precision));
    }
    return value;
  }

}
